import { GraphqlClient } from '@/services';
import {
  ApolloQueryResult,
  QueryOptions,
  MutationOptions
} from 'apollo-client';
import { FetchResult } from 'apollo-link';
import { NormalizedCacheObject } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { PaginatedResponse, QueryResponse } from '@/types';

export class ApiService {
  gqClient: ApolloClient<NormalizedCacheObject>;
  gqPubClient: ApolloClient<NormalizedCacheObject>;

  constructor() {
    this.gqClient = GraphqlClient.create({}, true);
    this.gqPubClient = GraphqlClient.create();
  }

  public async query<T>(
    queryOptions: QueryOptions,
    dataKey?: string
  ): Promise<T> {
    if (dataKey) {
      const result: ApolloQueryResult<
        QueryResponse<T>
      > = await this.gqClient.query<QueryResponse<T>>(queryOptions);
      return result.data[dataKey];
    } else {
      const result: ApolloQueryResult<T> = await this.gqClient.query<T>(
        queryOptions
      );
      return result.data;
    }
  }

  public async pubQuery<T>(
    queryOptions: QueryOptions,
    dataKey?: string
  ): Promise<T> {
    const result: ApolloQueryResult<any> = await this.gqPubClient.query<T>(
      queryOptions
    );
    return dataKey ? result.data![dataKey] : result.data;
  }

  public async mutate(
    mutationOptions: MutationOptions,
    dataKey?: string
  ): Promise<any> {
    const result: FetchResult<any> = await this.gqClient.mutate(
      mutationOptions
    );
    return dataKey ? result.data![dataKey] : result.data;
  }

  public async pubMutate(
    mutationOptions: MutationOptions,
    dataKey?: string
  ): Promise<any> {
    const result: FetchResult<any> = await this.gqPubClient.mutate(
      mutationOptions
    );
    return dataKey ? result.data![dataKey] : result.data;
  }

  protected objectToFormData(
    obj: object,
    form?: FormData,
    namespace?: string
  ): FormData {
    // if form is passed in through recursion assign otherwise create new
    const formData: FormData = form || new FormData();
    // @ts-ignore
    Object.entries(obj).forEach(([key, value]) => {
      let formKey = namespace ? `${namespace}[${key}]` : key;

      // if the property is an object, but not a File, use recursion.
      if (typeof value === 'object' && !(value instanceof File)) {
        // untested recursion
        this.objectToFormData(value, formData, key);
      } else {
        // if it's a string or a File
        formData.append(formKey, value);
      }
    });
    return formData;
  }
}
